import api from './client';
import { getOAuthCallbackOrigin } from './client';

// Google OAuth API
export const googleAPI = {
  getAccounts: () => api.get('/integrations/google/accounts'),
  initiateAuth: (accountId) => api.get(`/integrations/google/auth/${accountId}`, {
    params: { origin: getOAuthCallbackOrigin() },
  }),
  disconnect: (accountId) => api.delete(`/integrations/google/${accountId}`),
  getEmails: (accountId, query, maxResults = 20) => 
    api.get(`/integrations/google/${accountId}/emails`, { params: { query, max_results: maxResults } }),
  scanInvoices: (accountId) => api.post(`/integrations/google/${accountId}/scan-invoices`),
  // 202 + job id (Prompt 21 FIX 3): the actual scan runs in the
  // background, single-flighted per account -- poll processInvoicesJobStatus.
  processInvoices: (accountId, { forceRescan = false } = {}) => api.post(`/integrations/google/${accountId}/process-invoices`, null, { params: { force_rescan: forceRescan } }),
  processInvoicesJobStatus: (accountId, jobId) =>
    api.get(`/integrations/google/${accountId}/process-invoices/job-status/${jobId}`),
  processAllInvoices: ({ forceRescan = false } = {}) => api.post('/integrations/google/process-all-invoices', null, { params: { force_rescan: forceRescan } }),
};
